import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    // The four gauge cards share the height of the gauge column equally, down to a floor: the ~32px header, the
    // 16px of content padding and the gauge floor below. Without it the card shrinks past the gauge and clips it.
    // Four floors plus the gaps still fit the column on a 1366x768 screen; shorter ones scroll the column.
    card: {
        flex: "1 1 0",
        minHeight: theme.spacing(28),
    },
    body: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
    },
    // Sized from the card's height as well as its width, so the gauge shrinks instead of overflowing a short card.
    // The floor stops the aspect ratio from shrinking the gauge below a legible size on short screens: the
    // percentage is drawn at 28 of the 200 viewBox units, so a 64px box still renders it at about 15px.
    // A floor only, never a fixed size, so it does not fight the card height the gauge column hands down.
    gauge: {
        display: "grid",
        alignContent: "center",
        height: "100%",
        maxWidth: "100%",
        minHeight: 64,
        minWidth: 0,
        aspectRatio: "200 / 120",
    },
    infoIcon: {
        display: "block",
        color: theme.palette.text.secondary,
        cursor: "help",
    },
}));
